import { render, staticRenderFns } from "./TaskListView.vue?vue&type=template&id=5279e366&scoped=true&"
import script from "./TaskListView.vue?vue&type=script&lang=js&"
export * from "./TaskListView.vue?vue&type=script&lang=js&"
import style0 from "./TaskListView.vue?vue&type=style&index=0&id=5279e366&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5279e366",
  null
  
)

export default component.exports